<template>
  <section v-if="engagement" class="bg-white rounded-xl border border-gray-100 shadow-sm p-5 md:p-6">
    <div class="tw-flex items-center justify-between mb-4">
      <h3 class="text-base font-semibold text-gray-900 m-0">Engagement</h3>
    </div>
    <p class="text-sm text-gray-500 mt-0 mb-3">
      Monthly active users over time, based on activity logged in the platform.
    </p>

    <div v-if="hasData" class="chart-container">
      <div class="chart-main">
        <SimpleLineChart :data="chartData"/>
      </div>

      <div class="chart-aside">
        <EcosystemInfoCard labelColor="#2E59FA" title="Monthly active (MAU)">
          <span class="text-lg">
            {{ engagement.mau }}
            <span class="text-muted">
              <DeltaPercentage :current="engagement.mau" :previous="engagement.mau_previous"/>
            </span>
          </span>
        </EcosystemInfoCard>

        <EcosystemInfoCard title="Weekly active (WAU)">
          <span class="text-lg">{{ engagement.wau }}</span>
        </EcosystemInfoCard>

        <EcosystemInfoCard title="Stickiness">
          <span class="text-lg">{{ engagement.stickiness }}%</span>
          <span class="text-muted">avg DAU / MAU</span>
        </EcosystemInfoCard>
      </div>
    </div>

    <div v-else class="text-sm text-gray-400 py-2">
      No activity data yet
    </div>

    <dl v-if="hasData" class="mt-4 pt-4 border-t border-gray-100 grid gap-x-6 gap-y-2 sm:grid-cols-2 text-xs text-gray-500 m-0">
      <div>
        <dt class="font-semibold text-gray-600 inline">MAU (Monthly Active Users):</dt>
        distinct users who took at least one action in the selected month.
      </div>
      <div>
        <dt class="font-semibold text-gray-600 inline">WAU (Weekly Active Users):</dt>
        distinct users active in the last 7 days of the period.
      </div>
      <div>
        <dt class="font-semibold text-gray-600 inline">DAU (Daily Active Users):</dt>
        distinct users active on a given day (averaged across the month).
      </div>
      <div>
        <dt class="font-semibold text-gray-600 inline">Stickiness:</dt>
        avg DAU ÷ MAU — how often your monthly users come back.
      </div>
    </dl>
  </section>
</template>

<script>
  import { parseChartData } from '../../Chart/chartsMixin.js'
  import SimpleLineChart from '../../../components/Chart/SimpleLineChart.vue'
  import EcosystemInfoCard from './EcosystemInfoCard.vue'
  import DeltaPercentage from './DeltaPercentage.vue'

  export default {
    name: 'HeartbeatEngagement',
    components: {
      SimpleLineChart,
      EcosystemInfoCard,
      DeltaPercentage,
    },
    props: {
      engagement: Object,
    },
    computed: {
      hasData () {
        const perMonth = this.engagement && this.engagement.mau_per_month
        if (!perMonth) {
          return false
        }

        return Object.values(perMonth).some(value => value > 0)
      },
      chartData () {
        if (!this.engagement || !this.engagement.mau_per_month) {
          return null
        }

        return parseChartData([{
          color: '#2E59FA',
          label: 'Monthly active users',
          cumulate: false,
          data: this.engagement.mau_per_month,
        }])
      },
    },
  }
</script>
